import React, { Component, useEffect, useState } from "react"

import Nav from "../components/shared/Nav"
import { Button, Menu, Responsive, Sidebar } from "semantic-ui-react"
import { connect } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/pro-light-svg-icons"
import { routerPaths } from "../constants/paths"
import { Route } from "react-router-dom"
import { withRouter } from "react-router"

const TiresLayout = ({ children, history, dispatch }) => {
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [offersExit, setOffersExit] = useState(false)

  const getCurrentComponent = () => {
    const steps = [
      {
        route: routerPaths.selectVehicle,
        hideBottomBar: true
      },
      {
        route: routerPaths.tireSize
      }
    ]

    const currentRoute = location.pathname
    let currentStep
    steps.find((step, index) => {
      if (step.route === currentRoute) {
        currentStep = { step: index + 1, ...step }
        return true // important: boolean return for `find`
      }
      return false
    })
    return currentStep
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    if (queryParams.get("exit") === "offers") {
      setOffersExit(true)
    }
  }, [])

  const cancelTiresFlow = () => {
    dispatch({
      type: "TIRE_CART_ITEM",
      payload: {
        cartTireObject: null,
        tireQuantity: 0
      }
    })

    if (offersExit) {
      history.push(routerPaths.offers)
      return
    }

    history.push(routerPaths.dashboard)
  }

  return (
    <>
      <div className="flex">
        <div className="hidden md:block">
          <Nav />
        </div>
        <div className="main flex-grow-1">
          <div>
            <Responsive minWidth={Responsive.onlyTablet.minWidth}>
              <Menu
                borderless
                size="massive"
                className="borderless-outline site-header computer only flex-wrap flex justify-between"
              >
                <Menu.Item className="fleet-label">Tires</Menu.Item>
                <Menu.Menu position="right">
                  <Button onClick={cancelTiresFlow} className="secondary-btn">
                    {location.pathname.includes("/tires/order/") ? "Exit" : "Cancel"}
                  </Button>
                </Menu.Menu>
              </Menu>
            </Responsive>
            <Responsive maxWidth={Responsive.onlyTablet.minWidth}>
              <div className="flex justify-between items-center navbar-color print:!hidden">
                <div className="w-10 pl-4 text-black text-2xl text-bold">
                  <FontAwesomeIcon
                    icon={faBars}
                    className="text-white"
                    onClick={() => setSidebarVisible(true)}
                  />
                </div>
                <p className="tires-label">Tires</p>
                <button onClick={cancelTiresFlow} className="cancel-button">
                  {location.pathname.includes("/tires/order/") ? "Exit" : "Cancel"}
                </button>
              </div>
            </Responsive>
            <Sidebar
              visible={sidebarVisible}
              animation="overlay"
              onHide={() => setSidebarVisible(false)}
              width="thin"
              className="!absolute"
            >
              <Nav mobile={true} />
            </Sidebar>
          </div>
          <div stretched className="content">
            {React.Children.map(children, (child) => {
              if (React.isValidElement(child) && child.type === Route) {
                const originalRender = child.props.render
                if (typeof originalRender === "function") {
                  return React.cloneElement(child, {
                    render: (routeProps) => {
                      const rendered = originalRender(routeProps)
                      return React.isValidElement(rendered)
                        ? React.cloneElement(rendered, { step: getCurrentComponent() })
                        : rendered
                    }
                  })
                }
              }
              return child
            })}
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state, props) => {
  return {
    mobileMenuOpen: state.application.mobileMenuOpen
  }
}

export default withRouter(connect(mapStateToProps)(TiresLayout))

export const TiresBottomNav = ({
  goBack = () => {},
  next = () => {},
  nextDisabled,
  loading,
  nextBtnText,
  showBackBtn = true,
  showNextBtn = true
}) => {
  return (
    <>
      <div
        className="fixed bg-white bottom-0 h-20 shadow-5xl tire-bottom-nav"
        style={{ boxShadow: "0px -1px 5px rgba(50, 50, 50, 0.75)" }}
      >
        <div className="max-w-[1200px] mx-auto flex items-center h-full justify-between px-5 tires-bottom-nav">
          {showBackBtn && (
            <Button className="secondary-btn" onClick={goBack}>
              Go back
            </Button>
          )}
          {showNextBtn && (
            <Button onClick={next} disabled={!nextDisabled} loading={loading} className="next-btn">
              {nextBtnText ? nextBtnText : "Continue"}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
